import PropTypes from 'prop-types';
import React from 'react';
import ReactRouterLink from '../../ReactRouterLink';
import './GroupHomeLink.scss';

export default class GroupHomeLink extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * text that will be displayed on the button
         */
        displayText: PropTypes.string,
    };

    static defaultProps = {
        displayText: 'Back to group page',
    };

    render() {
        return (
            <div className="component-Groups-Elements-GroupHomeLink">
                <ReactRouterLink to="/">
                    <div className="home-link">{this.props.displayText}</div>
                </ReactRouterLink>
            </div>
        );
    }
}
